import { FC } from 'react';

type Props = {
    className?: string;
};

const MoneyNotFound02IconSolid: FC<Props> = ({ className }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            fill="#2B2B2B"
            stroke="none"
            className={className}
        >
            <path
                d="M2.11908 2.11908C2.44452 1.79364 2.97215 1.79364 3.29759 2.11908L17.8809 16.7024C18.2063 17.0278 18.2063 17.5555 17.8809 17.8809C17.5555 18.2063 17.0278 18.2063 16.7024 17.8809L2.11908 3.29759C1.79364 2.97215 1.79364 2.44452 2.11908 2.11908Z"
                fill="inherit"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.3908 8.08838C7.84705 8.54695 7.5013 9.23304 7.5013 10C7.50137 11.3806 8.62064 12.5 10.0013 12.5C10.7683 12.5 11.4536 12.1535 11.9121 11.6097L16.5874 16.285C16.4497 16.3149 16.3079 16.3417 16.161 16.3615C15.4402 16.4584 14.5242 16.4584 13.3884 16.4584H6.61426C5.47839 16.4584 4.56239 16.4584 3.84164 16.3615C3.13847 16.267 2.53914 16.0713 2.05371 15.634L1.95849 15.5428C1.45693 15.0412 1.24067 14.4097 1.13981 13.6597C1.04293 12.939 1.04294 12.0229 1.04297 10.887V9.11295C1.04294 7.97714 1.04294 7.06107 1.13981 6.34034C1.24065 5.59028 1.45694 4.95878 1.95849 4.4572C2.46009 3.9556 3.09155 3.73936 3.84164 3.63851C3.87084 3.63459 3.90049 3.63155 3.93034 3.62793L8.3908 8.08838ZM4.58464 9.1667C4.1244 9.1667 3.7513 9.53979 3.7513 10C3.75137 10.4602 4.12444 10.8334 4.58464 10.8334H4.59278L4.67823 10.8293C5.09839 10.7866 5.42604 10.4314 5.42611 10C5.42611 9.56854 5.09842 9.21345 4.67823 9.1707L4.59278 9.1667H4.58464Z"
                fill="inherit"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.3877 3.5415C14.5236 3.54148 15.4396 3.54145 16.1603 3.63835C16.9104 3.7392 17.5419 3.95544 18.0435 4.45703C18.545 4.95861 18.7613 5.59011 18.8621 6.34017C18.959 7.06091 18.959 7.97697 18.959 9.11279V10.8869C18.959 12.0227 18.959 12.9388 18.8621 13.6595C18.7766 14.2958 18.6062 14.8455 18.251 15.3042L12.451 9.5042C12.2532 8.52087 11.479 7.74612 10.4955 7.54866L6.48828 3.5415H13.3877ZM15.4173 9.16654C14.9571 9.16654 14.584 9.53962 14.584 9.99987C14.5841 10.46 14.9571 10.8332 15.4173 10.8332H15.4255L15.5109 10.8291C15.9311 10.7865 16.2587 10.4312 16.2588 9.99987C16.2588 9.56837 15.9311 9.21329 15.5109 9.17054L15.4255 9.16654H15.4173Z"
                fill="inherit"
            />
        </svg>
    );
};

export default MoneyNotFound02IconSolid;
